import React, { useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import useCompanies from "../../hooks/useCompanies";
import useAuth from "../../hooks/useAuth";
import { toast } from "react-toastify";

const InvitationStep1 = ({ registrationId, companyId, step1Result }) => {
  const { getCompany } = useCompanies();
  const { checkEmailExistence } = useAuth();
  const [company, setCompany] = useState(registrationId);

  useEffect(() => {
    if (!companyId) return;
    fetchData();
    return () => {};
  }, [companyId]);

  const fetchData = async () => {
    try {
      const _company = await getCompany(companyId);
      if (!_company) return;
      setCompany(_company);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    const { status } = await checkEmailExistence(
      `${registrationId}@${companyId}.com`
    );
    if (status) {
      toast.error("Email already exist");
      return;
    }
    step1Result({
      company: companyId,
      email: `${registrationId}@${companyId}.com`,
      firstname: registrationId,
      surname: companyId,
    });
  };

  return (
    <div>
      RegistrationId {registrationId}
      <br />
      company {company?.name}
      <br />
      email {`${registrationId}@${companyId}.com`}
      <br />
      firstName {registrationId}
      <br />
      lastName {companyId}
      <br />
      <button onClick={handleSubmit}>Submit</button>
    </div>
  );
};

InvitationStep1.propTypes = {
  registrationId: PropTypes.string,
  companyId: PropTypes.string,
  step1Result: PropTypes.func,
};

export default InvitationStep1;
